import BaseService from "./BaseService";

export default class ContactService extends BaseService {
  static endPoint = "contact";
}
